import React from 'react';
import classNames from 'classnames';
import MixedTypeIcon from '@/pages/home/components/MixedTypeIcon';
import type { IMarketGroupHeaderItemProps } from './type';

/** 右侧二级列表分组标题行（不可勾选；组头 icon 由 injectGroupHeaders 从组内首项注入） */
const MarketGroupHeaderItem: React.FC<IMarketGroupHeaderItemProps> = ({
  icon,
  svgIconType,
  render,
  title,
  rawText,
  isNotRegionIcon = false,
  imgInvert = [],
}) => (
  <div className="dbc-region-select-item-group-header">
    {render || (
      <>
        <MixedTypeIcon
          icon={icon}
          svgIconType={svgIconType}
          rawText={rawText}
          imgInvert={imgInvert}
          className={classNames('dbc-region-select-item-icon', {
            'device-icon': isNotRegionIcon,
          })}
        />
        <span className="dbc-region-select-item-group-header-text">{title}</span>
      </>
    )}
  </div>
);

export default MarketGroupHeaderItem;
